import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        async getResourcesByEntity(entityClass, entityId) {
            var meta = { clientApiMethod: 'getResourcesByEntity', input: { entityClass: entityClass, entityId: entityId } }
            var response = await client().get(`${store.state.apiRouteRoot}${entityClass}/${entityId}/Documents`, { meta: meta })
            return response?.data;
        },


        async uploadResourceToEntity(entityClass, entityId, documentTypeId, files, externalContent) {
            //console.log('uploadResourceToEntity', entityClass, entityId, documentTypeId, files, externalContent);
            let formData = new FormData();
            var filenames = [];
            if (files) {
                for (var filekey in files) {
                    if (Object.prototype.hasOwnProperty.call(files, filekey)) {
                        const file = files[filekey];
                        formData.append("Files", file, file.name);
                        filenames.push(file.name);
                    }
                }
            }
            if (externalContent && externalContent.length) {
                //formData.append("ExternalContent", JSON.stringify(externalContent));
                for (let index = 0; index < externalContent.length; index++) {
                    const element = externalContent[index];
                    //console.log('element', element);
                    formData.append(`ExternalContent[${index}].Name`, element.Name);
                    formData.append(`ExternalContent[${index}].Content`, element.Content);
                    formData.append(`ExternalContent[${index}].PublishToCustomer`, element.PublishToCustomer);
                }
            }
            formData.append("DocumentTypeId", documentTypeId);

            var meta = {
                clientApiMethod: 'uploadResourcesToEntity',
                input: { entityClass: entityClass, entityId: entityId, documentTypeId: documentTypeId, filenames: filenames, externalContent: externalContent },
                successText: i18n.t("servicesystem.responses.upload_success"),
            }
            var response = await client().post(`${store.state.apiRouteRoot}${entityClass}/${entityId}/Documents`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                transformRequest: formData => formData,
                meta: meta
            });
            return response?.data;
        },


        async togglePublishToCustomer(entityClass, documentTypeId, documentId) {
            var meta = {
                clientApiMethod: 'togglePublishToCustomer',
                input: { entityClass: entityClass, documentTypeId: documentTypeId, documentId: documentId }
            }
            var response = await client().patch(`${store.state.apiRouteRoot}${entityClass}/Documents/${documentId}/${documentTypeId}/TogglePublishToCustomer`, null, { meta: meta })
            return response?.data;
        },

        async bulkDeleteResources(dtos) {
            const meta = {
                clientApiMethod: 'bulkDeleteResources',
                input: { dtos: dtos },
                successText: i18n.t("servicesystem.responses.deleted_success")
            };
            const ec = dtos[0].entityClass; //use the first one to determine the endpoint
            var response = await client().delete(`${store.state.apiRouteRoot}${ec}/Documents/Bulk`, { data: dtos, meta: meta })
            return response?.data;
        },

        async deleteResourcesFromEntity(entityClass, entityId, documentTypeId, documentId) {
            var meta = {
                clientApiMethod: 'getResourcesByEntity',
                input: { entityClass: entityClass, entityId: entityId, documentTypeId: documentTypeId, documentId: documentId },
                successText: i18n.t("servicesystem.responses.deleted_success"),
            }
            var response = await client().delete(`${store.state.apiRouteRoot}${entityClass}/${entityId}/Documents/${documentId}/${documentTypeId}`, { meta: meta })
            return response?.data;
        },


        async sendEmail(emailDto) {
            var meta = {
                clientApiMethod: 'sendEmail',
                input: { emailDto },
                successText: i18n.t("servicesystem.common_objects.commonterms.success")
            }
            var response = await client().post(store.state.apiRouteRoot + 'Email/Send', emailDto, { meta: meta })
            return response?.data;
        },
    }
}